import React, { Fragment, useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { stateAbbreviations } from '../../../common/utils';
import { Typeahead } from 'react-bootstrap-typeahead';
import { loadContactLoans, addBorrowersToLoan, createLoan } from '../../../common/api';
import { formatShorthand } from '../../../common/utils';
import { toast } from 'react-toastify';

import '../modals.css';

const AddLoan = ( { close, aid, uid, cid, pStatus, pPurpose, pStage, contacts, loans, opps } ) => {
    const nav = useNavigate();

    const [ name, setName ] = useState();
    const [ purpose, setPurpose ] = useState();
    const [ stage, setStage ] = useState();
    const [ status, setStatus ] = useState();
    const [ hasLoanNum, setShowLoanNum ] = useState( false );
    const [ loanNum, setLoanNum ] = useState();
    const [ hasAddr, setShowAddr ] = useState( false );
    const [ addr, setAddr ] = useState();
    const [ city, setCity ] = useState();
    const [ state, setState ] = useState();
    const [ zip, setZip ] = useState();
    const [ role, setRole ] = useState( '' );
    const [ singleSelections, setSingleSelections ] = useState( [] );
    const [ priLoans, setPriLoans ] = useState( [] );
    const [ cList, setContactList ] = useState( [] );
    const [ c, setContact ] = useState( {} );
    const [ loid, setLeadOpp ] = useState();
    const [ pickLeadOpp, setPickLeadOpp ] = useState( true );

    const create = async () => {
        const loan = {
            name: name,
            purpose: purpose,
            stage: stage,
            status: status,
            fileNum: loanNum,
            subjectAddress: addr,
            subjectCity: city,
            subjectState: state,
            subjectZip: zip,
        };
        const borrowers = [ { cid: cid, label: 'Primary' } ];

        const added = await createLoan( c.aid, uid, loan, borrowers, loid );
        if ( added.length ) {
            toast.success( `The '${name}' loan has been created`, { theme: 'dark' } );
            close();
            // nav( `/loan/${added[0]}` );
        }
    }

    const add = async ( lid, name ) => {
        const added = await addBorrowersToLoan( c.aid, uid, lid, [ { cid: cid, label: 'Co-Borrower' } ] );
        if ( added.length === 1 ) {
            toast.success( `${c.firstname} is now a co-borrower on ${name}`, { theme: 'dark' } );
            close();
        }
    };

    useEffect( () => {
        let tmp = {};

        tmp = pPurpose.find( p => p.default );
        setPurpose( tmp ? tmp.value : pPurpose[0].value );

        tmp = pStatus.filter( f => f.object.includes( 'loan' ) ).find( p => p.default );
        const stat = ( tmp ) ? tmp.value : pStatus.filter( f => f.object.includes( 'loan' ) )[0].value;
        setStatus( stat );

        tmp = pStage.filter( f => f.bucket === stat ).find( p => p.default );
        setStage( tmp ? tmp.value : ( pStage.find( f => f.bucket === stat ) ) ? pStage.find( f => f.bucket === stat ).value : pStage.find( f => f.default ).value );
    }, [ pPurpose, pStage, pStatus ] );

    useEffect( () => {
        setContact( contacts[cid] );

        let list = [];
        Object.keys( contacts ).forEach( c => {
            if ( c !== cid ) {
                if ( ( aid !== 'TeamHunter') || ( !c.loId && uid !== 'brandon.carroll@ccm.com' ) || c.loId === uid ) {
                    list.push( contacts[c] );
                }
            }
         } );
        setContactList( list );
    }, [ contacts, cid, aid, uid ] );

    useEffect( () => {
        let list = [];
        Object.keys( opps ).forEach( loid => {
            const lo = opps[loid];
            const lor = lo.relationships?.find( f => f.cid === c.cid );
            if ( lor ) {
                if ( !lor.lid ) {
                    list.push( lo );
                }
            }
        } );
        if ( list.length === 1 ) {
            setLeadOpp( list[0].loid );
            setPickLeadOpp( false );
        }
    }, [ c, opps ] );

    useEffect( () => {
        const ln = ( hasLoanNum && loanNum && loanNum.length ) ? loanNum : 'TBD';
        setName( c.lastname + ' - ' + purpose + ' - Loan #' + ln );
    }, [ c, purpose, loanNum, hasLoanNum ] );

    useEffect( () => {
        if ( singleSelections.length === 1 ) {
            console.log( singleSelections[0] );
            let list = [];
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];
                if ( l && l.borrowers && l.borrowers.length ) {
                    const yes = l.borrowers.find( f => f.cid === singleSelections[0].cid );
                    if ( yes ) {
                        list.push( l );
                    }
                }
            } );
            setPriLoans( list );
        } else {
            setPriLoans( [] );
        }

    }, [ aid, uid, singleSelections, loans ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Create a New Loan</Col>
                </Row>
                <Row className='py-2'>
                    <Col>
                        <Form.Group>
                            <Form.Label>{c.firstname} will be the:</Form.Label>
                            <Row>
                                <Col xs='auto'><Form.Check
                                    inline
                                    label="Primary Borrower"
                                    name='role'
                                    type='radio'
                                    id='PriBo'
                                    onChange={ ( e ) => setRole( 'pri' ) }
                                /></Col>
                                <Col xs='auto'><Form.Check
                                    inline
                                    label='Co-Borrower'
                                    name='role'
                                    type='radio'
                                    id='CoBo'
                                    onChange={ ( e ) => setRole( 'cobo' ) }
                                /></Col>
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
                {
                    ( role === 'pri' ) ? (
                        <Fragment>
                            <Row className='py-2'>
                                <Col>
                                    <Form.Group>
                                        <Form.Control className='tf-modal-text-input form-control-plaintext' type="text" value={name} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Purpose of this loan</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={purpose} onChange={ ( e ) => setPurpose( e.target.value ) }>
                                            {
                                                pPurpose.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Current Status of this loan</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={status} onChange={ ( e ) => setStatus( e.target.value ) }>
                                            {
                                                pStatus.filter( f => f.object.includes( 'loan' ) ).map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Current Stage of this loan</Form.Label>
                                        <Form.Select size='sm' className='tf-modal-text-input' value={stage} onChange={ ( e ) => setStage( e.target.value ) }>
                                            {
                                                pStage.filter( f => f.bucket === status ).map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Have a loan number yet?</Form.Label>
                                        <Form.Check type='switch' id='loan-num-switch' label='Yes' onChange={ ( e ) => setShowLoanNum( !hasLoanNum ) } />
                                    </Form.Group>
                                </Col>
                                {
                                    hasLoanNum ? (
                                        <Col xs='auto'>
                                            <Form.Group>
                                                <Form.Label>Loan Number</Form.Label>
                                                <Form.Control className='tf-modal-text-input' type='text' id='loan-num' value={loanNum} onChange={ ( e ) => setLoanNum( e.target.value ) } />
                                            </Form.Group>
                                        </Col>
                                    ) : (
                                        <Fragment />
                                    )
                                }
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Form.Group>
                                        <Form.Label>Have a specific address yet?</Form.Label>
                                        <Form.Check type='switch' id='addr-switch' label='Yes' onChange={ ( e ) => setShowAddr( !hasAddr ) } />
                                    </Form.Group>
                                </Col>
                                {
                                    hasAddr ? (
                                        <Container fluid>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Street</Form.Label>
                                                        <Form.Control className='tf-modal-text-input' type='text' id='addr-street' value={addr} onChange={ ( e ) => setAddr( e.target.value ) } />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>City</Form.Label>
                                                        <Form.Control className='tf-modal-text-input' type='text' id='addr-city' value={city} onChange={ ( e ) => setCity( e.target.value ) } />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs='auto'>
                                                    <Form.Group>
                                                        <Form.Label>State</Form.Label>
                                                        <Form.Select size='sm' className='tf-modal-text-input' value={state} onChange={ ( e ) => setState( e.target.value ) }>
                                                            {
                                                                stateAbbreviations.map( ( s, idx ) => <option key={idx} value={s}>{s}</option>)
                                                            }
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col style={ { maxWidth: '100px' } }>
                                                    <Form.Group>
                                                        <Form.Label>Zip</Form.Label>
                                                        <Form.Control className='tf-modal-text-input' type='text' id='addr-zip' value={zip} onChange={ ( e ) => setZip( e.target.value ) } />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Container>
                                    ) : (
                                        <Fragment />
                                    )
                                }
                            </Row>
                            <Row className='py-2'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() }>Create</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment />
                    )
                }
                {
                    ( role === 'cobo' ) ? (
                        <Fragment>
                            <Row className='align-items-center'>
                                <Col xs='auto'>On a Loan With:</Col>
                                <Col xs='auto'>
                                    <Typeahead
                                        filterBy={ [ 'firstname', 'lastname', 'email' ] }
                                        id="tf-pribo-finder"
                                        labelKey={ ( option ) => `${option.firstname} ${option.lastname}` }
                                        onChange={setSingleSelections}
                                        selected={singleSelections}
                                        options={ cList }
                                        placeholder="Enter name or email..."
                                        renderMenuItemChildren={ ( option ) => (
                                            <div>
                                                {option.firstname + ' ' + option.lastname}
                                                <div>
                                                    <small>Email: {option.email}</small>
                                                </div>
                                            </div>
                                        )}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                {
                                    ( priLoans.length > 0 ) ? (
                                        <ListGroup variant='flush'>
                                        {
                                            priLoans.map( l => {
                                                return (
                                                    <ListGroup.Item key={l.id}>
                                                        <Row className='align-items-center'>
                                                            <Col xs='auto' className='tf-sidebar-obj-value'>
                                                                {l.status}
                                                            </Col>
                                                            <Col>
                                                                <Row className='align-items-center'>
                                                                    <Col xs='auto' className='tf-sidebar-obj-key-date-container'>
                                                                        <span className='tf-sidebar-obj-key-date'>{l.name}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col className='tf-sidebar-obj-desc'>
                                                                        ${formatShorthand( l.amount )} {l.purpose}
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xs='auto'><Button size='sm' variant='outline-primary' onClick={ () => add( l.lid, l.name ) }>+ Add</Button></Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                )
                                            } )
                                        }
                                        </ListGroup>
                                    ) : ( singleSelections.length === 1 ) ? (
                                        <Col>Hmm, it doesn't look like {singleSelections[0].name} has any loans yet.  Should we add one now?</Col>
                                    ) : (
                                        <Fragment />
                                    )
                                }
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment />
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    cid: state.contacts.currentId,
    pStatus: state.user.meta.loan.picklist.status,
    pStage: state.user.meta.loan.picklist.stage,
    pPurpose: state.user.meta.global.picklist.purpose,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    opps: state.leadopps.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( AddLoan );